import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class MyEventListItem extends SearchModelBase {
  id: number = 0;
  mCntrId: number = 0;
  hCntrId: number = 0;
  mblId: number = 0;
  hblId: number = 0;
  eventStatus: string = '';
  containerNo: string = '';
  mblNo: string = '';
  // trStatus: string = '';
  te: boolean = false;      // MBL List > T와 동일한 컬럼
  cargo: string = '';
  hblNo: string = '';
  pod: string = '';
  eta: string | null = null;
  lastFreeDay: string | null = null;
  vesselArrivalDate: string | null = null;
  unloadVesselDate: string | null = null;
  railDepartureDate: string | null = null;
  railArrivalDate: string | null = null;
  anSentDate: string | null = null;
  mblCarrierRlsDate: string | null = null;    // MBL Carrier Release 필드를 업데이트 할지 판단하기 위한 용도
  carrierRlsDate: string | null = null;
  customsRlsDate: string | null = null;
  pickupAvailableDate: string | null = null;
  pickupDate: string | null = null;
  emptyCntrRtnDate: string | null = null;
  billingsDate: string | null = null;
  consignee: string | null = null;
  // trType: string | null = null;
  // trDate: string | null = null;

  anPastDays: number = 0;
  carrierRlsPastDays: number = 0;
  customsRlsPastDays: number = 0;
  carrierRlsFromEtaPastDays: number = 0;
  customsRlsFromEtaPastDays: number = 0;
  demurragePastDays: number = 0;
  detentionPastDays: number = 0;
  billingPastDays: number = 0;

  fromEtaDate: string | null = null;
  toEtaDate: string | null = null;

  fromLfdDate: string | null = null;
  toLfdDate: string | null = null;

  fromVesselArrivalDate: string | null = null;
  toVesselArrivalDate: string | null = null;

  fromUnloadVesselDate: string | null = null;
  toUnloadVesselDate: string | null = null;

  fromRailDepartureDate: string | null = null;
  toRailDepartureDate: string | null = null;

  fromRailArrivalDate: string | null = null;
  toRailArrivalDate: string | null = null;

  fromANSentDate: string | null = null;
  toANSentDate: string | null = null;

  fromCarrierRlsDate: string | null = null;
  toCarrierRlsDate: string | null = null;

  fromCustomsRlsDate: string | null = null;
  toCustomsRlsDate: string | null = null;

  fromPickupAvailableDate: string | null = null;
  toPickupAvailableDate: string | null = null;

  fromPickupDate: string | null = null;
  toPickupDate: string | null = null;

  fromEmptyCntrRtnDate: string | null = null;
  toEmptyCntrRtnDate: string | null = null;

  fromBillingsDate: string | null = null;
  toBillingsDate: string | null = null;

  // fromTrDate: string | null = null;
  // toTrDate: string | null = null;

  preparedBy: string | null = null;

  private static ExportCollection: XCol.XExportColumn[] = [
    XCol.Create({ col: 0,   text: '',                 width: 30,      dataIndex: 'status',              hiddenInColumnSetup: true, sortable: false}),
    XCol.Create({ col: 1,   text: 'My Events',        width: 125,     dataIndex: 'eventStatus'}),
    XCol.Create({ col: 2,   text: 'CNTR #',          width: 100,     dataIndex: 'containerNo',         defaultColumnFocus: true}),
    XCol.Create({ col: 3,   text: 'MBL #',          width: 100,     dataIndex: 'mblNo'}),
    // XCol.Create({ col: 4,   text: 'TR',                width: 30,      dataIndex: 'trStatus',            align: XCol.XAlignType.Center}),
    // XCol.Create({ col: 4,   text: 'T',                width: 30,      dataIndex: 'te',                  type: XCol.XCellType.Bool, noNullOrEmptySearch: true }),
    XCol.Create({ col: 4,   text: 'Cargo',            width: 50,      dataIndex: 'cargo'}),
    XCol.Create({ col: 5,   text: 'HBL #',          width: 100,     dataIndex: 'hblNo'}),
    XCol.Create({ col: 6,   text: 'POD',              width: 100,     dataIndex: 'pod'}),
    XCol.Create({ col: 7,   text: 'A/N Sent',         width: 75,      dataIndex: 'anSentDate',          type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    XCol.Create({ col: 8,   text: 'ETA',              width: 75,      dataIndex: 'eta',                 type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    XCol.Create({ col: 9,   text: 'LFD',              width: 75,      dataIndex: 'lastFreeDay',         type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    XCol.Create({ col: 10,  text: 'Vessel ARR',       width: 75,      dataIndex: 'vesselArrivalDate',   type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    XCol.Create({ col: 11,  text: 'Vessel ULD',       width: 75,      dataIndex: 'unloadVesselDate',    type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    XCol.Create({ col: 12,  text: 'Rail DEP',         width: 75,      dataIndex: 'railDepartureDate',   type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    XCol.Create({ col: 13,  text: 'Rail ARR',         width: 75,      dataIndex: 'railArrivalDate',     type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    XCol.Create({ col: 14,  text: 'Carrier Rel.',     width: 75,      dataIndex: 'carrierRlsDate',      type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    XCol.Create({ col: 15,  text: 'Cust Rel.',        width: 75,      dataIndex: 'customsRlsDate',      type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    XCol.Create({ col: 16,  text: 'Pickup Avail',     width: 75,      dataIndex: 'pickupAvailableDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    XCol.Create({ col: 17,  text: 'Pickup',           width: 75,      dataIndex: 'pickupDate',          type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    XCol.Create({ col: 18,  text: 'Emp RTN',          width: 75,      dataIndex: 'emptyCntrRtnDate',    type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    XCol.Create({ col: 19,  text: 'Billings',         width: 75,      dataIndex: 'billingsDate',        type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    XCol.Create({ col: 20,  text: 'Consignee',        width: 110,     dataIndex: 'consignee' }),
    // XCol.Create({ col: 22,  text: 'Req Date',         width: 75,      dataIndex: 'trDate',              type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
  ];

  public static getExportCollection(): XCol.XExportColumn[] {
      return this.ExportCollection;
  };

  public static OrderBy = { orderBy: MyEventListItem.prototype.id, orderByAscending: false };

  public static formatData(data: MyEventListItem[]) {
      return data.map((d: MyEventListItem) => ({
        ...d,
      }));
  }

  public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
    eta: {from: 'fromEtaDate', to: 'toEtaDate'},
    lastFreeDay: {from: 'fromLfdDate', to: 'toLfdDate'},
    vesselArrivalDate: {from: 'fromVesselArrivalDate', to: 'toVesselArrivalDate'},
    unloadVesselDate: {from: 'fromUnloadVesselDate', to: 'toUnloadVesselDate'},
    railDepartureDate: {from: 'fromRailDepartureDate', to: 'toRailDepartureDate'},
    railArrivalDate: {from: 'fromRailArrivalDate', to: 'toRailArrivalDate'},
    anSentDate: {from: 'fromANSentDate', to: 'toANSentDate'},
    carrierRlsDate: {from: 'fromCarrierRlsDate', to: 'toCarrierRlsDate'},
    customsRlsDate: {from: 'fromCustomsRlsDate', to: 'toCustomsRlsDate'},
    pickupAvailableDate: {from: 'fromPickupAvailableDate', to: 'toPickupAvailableDate'},
    pickupDate: {from: 'fromPickupDate', to: 'toPickupDate'},
    emptyCntrRtnDate: {from: 'fromEmptyCntrRtnDate', to: 'toEmptyCntrRtnDate'},
    billingsDate: {from: 'fromBillingsDate', to: 'toBillingsDate'},
    // trDate: {from: 'fromTrDate', to: 'toTrDate'},
  };
}
